import { useTheme } from '@mui/material';
import { colors } from '@watter/shared-components';

const DeleteAllNotification = () => {
    const theme = useTheme();
    const color = theme.palette.mode === 'dark' ? colors.white : colors.blackColor;
    return (
        <svg width="74" height="82" viewBox="0 0 74 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.44434 18.7778H72.5555M28.111 36.5556V63.2222M45.8888 36.5556V63.2222M5.88878 18.7778L10.3332 72.1111C10.3332 74.4686 11.2697 76.7295 12.9367 78.3965C14.6037 80.0635 16.8646 81 19.2221 81H54.7777C57.1352 81 59.3961 80.0635 61.0631 78.3965C62.7301 76.7295 63.6666 74.4686 63.6666 72.1111L68.111 18.7778M23.6666 18.7778V5.44444C23.6666 4.2657 24.1348 3.13524 24.9683 2.30175C25.8018 1.46825 26.9323 1 28.111 1H45.8888C47.0675 1 48.198 1.46825 49.0315 2.30175C49.865 3.13524 50.3332 4.2657 50.3332 5.44444V18.7778"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DeleteAllNotification;
